import React, {useEffect, useState} from "react";
import {getItems} from "../utils/communication";
import isAnError, {AnError} from "../model/misc";
import RecipeCard from "../components/cooking/recipe/recipe-card";
import ErrorDisplay from "../components/error-display";
import parseAnError from "../model/misc";

function Home() {
    const [recipes, setRecipes] = useState<Recipe[]>([]);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        document.title = "Hoarfroster";

        (async () => {
            let response = await getItems<Recipe>("/cooking/recipe/all");

            if (response.code !== 200) {
                setError(parseAnError(response.data).message);
            } else {
                setRecipes(response.data as Recipe[]);
            }
        })();
    }, []);

    return (
        <main>
            <div className="container">
                <div className="content space-y-4">
                    <h1>Recipes</h1>

                    <div className="recipes">
                        {recipes.map((recipe, index) => (
                            <RecipeCard recipe={recipe} needsSeparator={index !== recipes.length - 1}/>
                        ))}
                    </div>

                    <ErrorDisplay error={error}/>
                </div>

                <div className="sidebar space-y-2">
                    <h2>About</h2>
                    <p>欢迎来看烤鹅普拉斯做客！这里有好吃的、好看的、好玩的各种新奇古怪的食谱菜单原材料工具！</p>
                    <p>微信小程序：烤鹅普拉斯</p>
                </div>
            </div>
        </main>
    );
}

export default Home;